"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _react = _interopRequireDefault(require("react"));

var _default = function _default(collection) {
  collection = collection || [];
  var result = collection.models || collection;

  if (_react["default"].isValidElement(result)) {
    result = _react["default"].Children.toArray(result);
  }

  result = result.map(function (item) {
    // already transformed by processor to React element
    if (_react["default"].isValidElement(item)) {
      return {
        id: item.props.value,
        stringName: item.props.name,
        name: item
      }; // plain value in array
    } else if (typeof item === 'string' || typeof item === 'number') {
      return {
        id: item,
        name: item,
        stringName: item
      }; // Backbone Model
    } else if (typeof item.get === 'function') {
      var name = typeof item.name === 'function' && item.name() || item.get('name') || item.id || '';
      return {
        id: item.id,
        name: name,
        stringName: name
      }; // plain object
    } else if ((0, _typeof2["default"])(item) === 'object') {
      return {
        id: item.id,
        name: item.name || item.id || '',
        stringName: item.name || item.id || ''
      };
    } else if (typeof item === 'function') {
      var component = item();
      return {
        id: component.props.value,
        stringName: component.props.name,
        name: component,
        render: function render(props) {
          return item(props);
        }
      };
    }
  });
  return result;
};

exports["default"] = _default;